// ** Router imports
import { lazy, useContext } from 'react'

// ** Router imports
import { useRoutes, Navigate } from "react-router-dom"

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'

// ** GetRoutes
import { getRoutes } from "./routes"

// ** Hooks Imports
import { useLayout } from "@hooks/useLayout"

import { AuthContext } from '@context/AuthContext'

// ** Components
const Error = lazy(() => import('@views/Error'))
const Login = lazy(() => import('@views/Login'))
const NewPassword = lazy(() => import("@views/NewPassword"))
const ResetPassword = lazy(() => import("@views/ResetPassword"))
const NotAuthorized = lazy(() => import('@views/NotAuthorized'))
const ForgotPassword = lazy(() => import("@views/ForgotPassword"))
const ChangePassword = lazy(() => import("@views/ChangePassword"))
// const Sudalgaas = lazy(() => import("@views/Sudalgaa"))

const HomeRoute = "/home"
const LoginRoute = "/login"
// const SudalgaaRoute = "/sudalgaa"

const Router = () => {
    // ** Hooks
    const { layout } = useLayout()

    const allRoutes = getRoutes(layout)

    const { userDetail } = useContext(AuthContext)

    /** Хоосон '/' орж ирэхэд хаашаа үсэргэхийг заана */
    function getHomeRoute()
    {
        if (Object.keys(userDetail).length > 0)
        {
            return HomeRoute
        }
        else
        {
            return LoginRoute
        }
    }
    const routes = [
        {
            path: '/',
            index: true,
            element: <Navigate replace to={getHomeRoute()} />
        },
        {
            path: '/login',
            element: <Login />
        },
        // {
        //     path: '/sudalgaa',
        //     element: <Sudalgaas />
        // },
        {
            path: '/new-password/:token',
            element: <NewPassword />
        },
        {
            path: '/forgot-password',
            element: <ForgotPassword />
        },
        {
            path: '/reset-password',
            element: <BlankLayout />,
            children: [{ path: '/reset-password/:token', element: <NewPassword /> }]
        },
        // {
        //     path: '/reset-password',
        //     element: <ResetPassword />
        // },

        {
            path: '/change-password',
            element: <ChangePassword />
        },
        {
            path: '/auth/not-auth',
            element: <NotAuthorized />
        },
        {
            path: '*',
            element: <Error />
        },
        ...allRoutes
    ]

    return useRoutes(routes)
}

export default Router
